import React from 'react';

type Props = {} & React.SVGProps<SVGSVGElement>;

const SvgEnglishHybridFlag = (props: Props): JSX.Element => {
  return (
    // @ts-ignore
    <svg
      id="EnglishHybridFlag_svg__Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      width={24.39}
      height={12.88}
      {...props}
    >
      <defs>
        <style>
          {
            '.EnglishHybridFlag_svg__cls-1{fill:#bf2333}.EnglishHybridFlag_svg__cls-2,.EnglishHybridFlag_svg__cls-4{fill:#fff}.EnglishHybridFlag_svg__cls-4{fill-rule:evenodd}.EnglishHybridFlag_svg__cls-5{fill:#283575}.EnglishHybridFlag_svg__cls-6{fill:#d0232e}'
          }
        </style>
      </defs>
      <path
        id="EnglishHybridFlag_svg__rect8767"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03 11.75h24.26v1.03H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8769"
        className="EnglishHybridFlag_svg__cls-2"
        d="M.03 10.72h24.26v1.03H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8771"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03 9.7h24.26v1.03H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8773"
        className="EnglishHybridFlag_svg__cls-2"
        d="M.03 8.68h24.26v1.03H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8775"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03 7.72h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8777"
        className="EnglishHybridFlag_svg__cls-2"
        d="M.03 6.76h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8779"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03 5.79h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8781"
        className="EnglishHybridFlag_svg__cls-2"
        d="M.03 4.83h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8783"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03 3.87h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8785"
        className="EnglishHybridFlag_svg__cls-2"
        d="M.03 2.92h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8787"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03 1.96h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8791"
        className="EnglishHybridFlag_svg__cls-2"
        d="M.03.99h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8793"
        className="EnglishHybridFlag_svg__cls-1"
        d="M.03.03h24.26v.96H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__rect8796"
        fill="#223164"
        d="M.03.03h9.73v6.72H.03z"
      />
      <path
        id="EnglishHybridFlag_svg__path8825"
        className="EnglishHybridFlag_svg__cls-4"
        d="M.44 6h.28l.11-.28.11.28h.28L1 6.14l.07.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8827"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2 6h.28l.11-.28.15.28h.29l-.21.19.06.29-.24-.15-.23.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8829"
        className="EnglishHybridFlag_svg__cls-4"
        d="M3.7 6H4l.11-.28.09.28h.29l-.22.19.07.29-.24-.2-.25.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8831"
        className="EnglishHybridFlag_svg__cls-4"
        d="M5.3 6h.28l.11-.28.12.28h.28l-.21.19.06.29-.24-.2-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8833"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.9 6h.29l.1-.28.12.28h.28l-.21.19.07.29-.25-.2-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8835"
        className="EnglishHybridFlag_svg__cls-4"
        d="M8.57 6h.28L9 5.68l.08.32h.27l-.16.19v.3L9 6.29l-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8837"
        className="EnglishHybridFlag_svg__cls-4"
        d="M1.27 5.32h.28L1.66 5l.12.27h.28l-.21.2.06.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8839"
        className="EnglishHybridFlag_svg__cls-4"
        d="M.44 4.61h.28l.11-.28.11.28h.28l-.22.2.07.29L.83 5l-.24.1.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8841"
        className="EnglishHybridFlag_svg__cls-4"
        d="M1.27 4h.28l.11-.28.12.28h.28l-.21.2.06.29-.24-.15-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8843"
        className="EnglishHybridFlag_svg__cls-4"
        d="M.44 3.26h.28L.83 3l.11.26h.28l-.22.2.07.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8845"
        className="EnglishHybridFlag_svg__cls-4"
        d="M1.27 2.63h.28l.11-.27.12.27h.28l-.21.2.06.28L1.67 3l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8847"
        className="EnglishHybridFlag_svg__cls-4"
        d="M.44 1.93h.28l.11-.28.11.27h.28L1 2.11l.07.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8849"
        className="EnglishHybridFlag_svg__cls-4"
        d="M1.27 1.29h.28L1.66 1l.12.27h.28l-.21.2.06.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8851"
        className="EnglishHybridFlag_svg__cls-4"
        d="M.44.58h.28L.83.3l.11.28h.28L1 .78l.07.29L.83.92l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8853"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2.87 5.32h.28l.1-.32.12.27h.28l-.21.2.07.29-.25-.15-.26.2.05-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8855"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2 4.61h.28l.11-.28.11.28h.29l-.21.2.06.29-.2-.1-.24.1.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8857"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2.87 4h.28l.1-.28.12.28h.28l-.21.2.07.29-.25-.15-.26.12.05-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8859"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2 3.26h.28L2.43 3l.11.26h.29l-.21.2.06.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8861"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2.87 2.63h.28l.1-.27.12.27h.28l-.21.2.07.28L3.26 3 3 3.12l.05-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8863"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2 1.93h.28l.11-.28.11.27h.29l-.21.19.06.29-.24-.15-.23.2.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8865"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2.87 1.29h.28l.1-.29.12.27h.28l-.21.2.07.29-.25-.15-.26.17.05-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8867"
        className="EnglishHybridFlag_svg__cls-4"
        d="M2 .58h.28L2.43.3l.11.28h.29l-.21.2.06.29-.24-.15-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8869"
        className="EnglishHybridFlag_svg__cls-4"
        d="M4.47 5.32h.28L4.86 5l.14.31h.28l-.28.2.07.29-.25-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8871"
        className="EnglishHybridFlag_svg__cls-4"
        d="M3.7 4.61H4l.11-.28.11.28h.29l-.22.2.07.29L4.1 5l-.25.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8873"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.9 4.61h.29l.1-.28.12.28h.28l-.21.2.07.29L7.3 5l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8875"
        className="EnglishHybridFlag_svg__cls-4"
        d="M5.3 4.61h.28l.11-.28.12.28h.28l-.21.2.06.29L5.7 5l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8877"
        className="EnglishHybridFlag_svg__cls-4"
        d="M7.74 5.32H8L8.13 5l.11.27h.29l-.22.2.07.29-.24-.15-.25.16.11-.25z"
      />
      <path
        id="EnglishHybridFlag_svg__path8879"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.13 5.32h.29l.1-.32.12.27h.28l-.21.2.07.29-.25-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8881"
        className="EnglishHybridFlag_svg__cls-4"
        d="M3.7.58H4L4.09.3l.11.28h.29l-.22.2.07.29L4.1.92l-.25.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8883"
        className="EnglishHybridFlag_svg__cls-4"
        d="M4.47 1.29h.28L4.86 1l.14.28h.28l-.28.2.07.29-.25-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8885"
        className="EnglishHybridFlag_svg__cls-4"
        d="M3.7 1.93H4l.11-.28.11.27h.29l-.22.19.07.29-.26-.15-.25.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8887"
        className="EnglishHybridFlag_svg__cls-4"
        d="M4.47 2.63h.28l.11-.27.14.27h.28l-.28.2.07.28L4.86 3l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8889"
        className="EnglishHybridFlag_svg__cls-4"
        d="M3.7 3.26H4L4.09 3l.11.26h.29l-.22.2.07.29-.24-.15-.25.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8891"
        className="EnglishHybridFlag_svg__cls-4"
        d="M4.47 4h.28l.11-.28L5 4h.28L5 4.17l.07.29-.25-.15-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8893"
        className="EnglishHybridFlag_svg__cls-4"
        d="M8.57 4.61h.28L9 4.33l.12.28h.27l-.2.2v.29L9 5l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8895"
        className="EnglishHybridFlag_svg__cls-4"
        d="M5.3 3.26h.28L5.69 3l.12.26h.28l-.21.2.06.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8897"
        className="EnglishHybridFlag_svg__cls-4"
        d="M5.3.58h.28L5.69.3l.12.28h.28l-.21.2.06.29L5.7.92l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8899"
        className="EnglishHybridFlag_svg__cls-4"
        d="M5.3 1.93h.28l.11-.28.12.27h.28l-.21.19.06.29-.24-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8901"
        className="EnglishHybridFlag_svg__cls-4"
        d="M7.74 4H8l.11-.28.13.28h.29l-.22.2.07.29-.24-.15-.25.15.11-.32z"
      />
      <path
        id="EnglishHybridFlag_svg__path8903"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.13 4h.29l.1-.28.12.28h.28l-.21.2.07.29-.25-.15-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8905"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.13 1.29h.29l.1-.29.12.27h.28l-.21.2.07.29-.25-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8907"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.13 2.63h.29l.1-.27.12.27h.28l-.21.2.07.28L6.53 3l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8909"
        className="EnglishHybridFlag_svg__cls-4"
        d="M8.57 3.26h.28L9 3l.12.26h.27l-.16.18.06.29L9 3.58l-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8911"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.9 3.26h.29l.1-.26.12.26h.28l-.21.2.07.29-.25-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8913"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.9.58h.29l.1-.28.12.28h.28l-.21.2.07.29L7.3.92l-.24.15.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8915"
        className="EnglishHybridFlag_svg__cls-4"
        d="M6.9 1.93h.29l.1-.28.12.27h.28l-.21.19.07.29-.25-.15-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8917"
        className="EnglishHybridFlag_svg__cls-4"
        d="M8.57.58h.28L9 .3l.12.28h.27l-.2.2v.29L9 .92l-.24.15.03-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8919"
        className="EnglishHybridFlag_svg__cls-4"
        d="M7.74 1.29H8L8.13 1l.11.27h.29l-.22.2.07.29-.24-.15-.25.16.11-.28z"
      />
      <path
        id="EnglishHybridFlag_svg__path8921"
        className="EnglishHybridFlag_svg__cls-4"
        d="M8.57 1.93h.28L9 1.65l.12.27h.27l-.2.19v.34L9 2.3l-.24.16.06-.29z"
      />
      <path
        id="EnglishHybridFlag_svg__path8923"
        className="EnglishHybridFlag_svg__cls-4"
        d="M7.74 2.63H8l.11-.27.11.27h.29l-.22.2.07.28L8.14 3l-.25.15.11-.32z"
      />
      <path
        id="EnglishHybridFlag_svg__path3835"
        className="EnglishHybridFlag_svg__cls-2"
        d="M0 12.8L24.39.08v12.75z"
      />
      <path
        id="EnglishHybridFlag_svg__path3839"
        className="EnglishHybridFlag_svg__cls-5"
        d="M14.19 12.78V8.13h10.1v4.63z"
      />
      <path
        id="EnglishHybridFlag_svg__path3843"
        className="EnglishHybridFlag_svg__cls-5"
        d="M24.29.05L16 4.44h8.25z"
      />
      <path
        id="EnglishHybridFlag_svg__path3845"
        className="EnglishHybridFlag_svg__cls-5"
        d="M0 12.77l9.1-4.7h1.25v4.72z"
      />
      <path
        id="EnglishHybridFlag_svg__path3847"
        className="EnglishHybridFlag_svg__cls-2"
        d="M24.35 11.5v1.38h-2.18l-8.32-4.36.09-.61 3.69.1z"
      />
      <path
        id="EnglishHybridFlag_svg__path3855"
        className="EnglishHybridFlag_svg__cls-2"
        d="M24.37 0l-8.55 4.54 2.65.06 5.85-3.15z"
      />
      <path
        id="EnglishHybridFlag_svg__path3859"
        className="EnglishHybridFlag_svg__cls-2"
        d="M0 12.77l9.51-4.92h1v.93l-7.46 4z"
      />
      <path
        id="EnglishHybridFlag_svg__path4355"
        className="EnglishHybridFlag_svg__cls-6"
        d="M0 12.77l9.36-4.85h1v.5l-8.28 4.34z"
      />
      <path
        id="EnglishHybridFlag_svg__path4357"
        className="EnglishHybridFlag_svg__cls-6"
        d="M15.27 8l1.84.05 7.2 3.85v.84z"
      />
      <path
        id="EnglishHybridFlag_svg__path3058"
        className="EnglishHybridFlag_svg__cls-6"
        d="M24.29 7.44h-14L15 5.06h9.36z"
      />
      <path
        id="EnglishHybridFlag_svg__path3060"
        className="EnglishHybridFlag_svg__cls-6"
        d="M13.42 12.74V5.85L11 7.08v5.69z"
      />
    </svg>
  );
};

export default SvgEnglishHybridFlag;
